export default __webpack_public_path__ + "static/media/Gold.dfac5a43.svg";